export class CustomValidationError extends Error {
    constructor({ message, messageCode, templateParameters }) {
        super(message);
        this.messageCode = messageCode;
        this.templateParameters = templateParameters;
        this.name = 'CustomValidationError';
    }
}
